const styles = {
  cellText: {
    color: 'primary.greyMetal',
    fontSize: '12px',
    fontWeight: 500,
  },
};

export default styles;
